import React from 'react';
import { useTranslation } from 'react-i18next';

interface BrandLoadingProps {
  loadingText?: string;
  className?: string;
}

export const BrandLoading: React.FC<BrandLoadingProps> = ({
  loadingText,
  className = '',
}) => {
  const { t } = useTranslation('common');

  const displayText = loadingText || t('loading.app', 'Loading…');

  return (
    <div
      className={`fixed inset-0 grid place-items-center bg-[#070A0B] text-[#E2EDE7] font-sans z-50 ${className}`}
    >
      <div className="w-full max-w-[520px] px-6 py-6 flex flex-col items-center">
        <img
          src="/logo-header.svg"
          alt="Forecast Engine"
          width={220}
          height={66}
          className="h-auto w-[220px]"
        />
        <p className="mt-4 animate-pulse text-[#788A82] text-sm leading-relaxed font-sans">
          {displayText}
        </p>
      </div>
    </div>
  );
};

export default BrandLoading;
